// extracted by mini-css-extract-plugin
export default {"link":"search_link__1m69F","search":"search_search__sATPz","searchSection":"search_searchSection__YQEp3","input":"search_input__83aVR"};